import type { TableSelectedCell } from '@/components/custom/erp';
import type { PhieuChiCellValue } from '../../../types';
import { useTableRows } from '@/components/custom/erp';

export type SelectedCellInfo = TableSelectedCell;

type TaxRowBase = {
  uuid: string;
  line?: number;
  [key: string]: unknown;
};

export function useTaxRows<T extends TaxRowBase>(
  initialRows: T[] = [],
  onChange?: (rows: T[]) => void,
  onFieldValueChangeProp?: (row: T, field: string, value: PhieuChiCellValue) => Partial<T>
) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<T>({
    initialRows,
    onChange,
    onFieldValueChange: (row, field, value) =>
      ({
        ...(onFieldValueChangeProp?.(row, field, value) ?? {})
      }) as Partial<T>,
    defaultField: 'dien_giai'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
